import CountUp from "react-countup";
import React, {useEffect, useState} from "react";
import {CloseCircleOutlined} from "@ant-design/icons";
import {Col, Divider, InputNumber, Row, Statistic, Tag, Typography} from "antd";

const {Text} = Typography;

export function DashboardVegetationSequestration({
                                                     isOpenVegetationSequestration,
                                                     setIsOpenVegetationSequestration,
                                                     setEmMainVegetation,
                                                     data,
                                                     floorspaceTotal,
                                                     setErrorVegetationSequestration
                                                 }) {

    const [emTot, setEmTot] = useState(0)
    const [emTotPer, setEmTotPer] = useState(0)
    const [emRainforest, setEmRainforest] = useState(0)
    const [emPerRainforest, setEmPerRainforest] = useState(0)
    const [ratioRainforest, setRatioRainforest] = useState(0)
    const [areaRainforest, setAreaRainforest] = useState(0)
    const [areaChartRainforest, setAreaChartRainforest] = useState(0)
    const [emMangroves, setEmMangroves] = useState(0)
    const [emPerMangroves, setEmPerMangroves] = useState(0)
    const [ratioMangroves, setRatioMangroves] = useState(0)
    const [areaMangroves, setAreaMangroves] = useState(0)
    const [areaChartMangroves, setAreaChartMangroves] = useState(0)
    const [emPalmOil, setEmPalmOil] = useState(0)
    const [emPerPalmOil, setEmPerPalmOil] = useState(0)
    const [ratioPalmOil, setRatioPalmOil] = useState(0)
    const [areaPalmOil, setAreaPalmOil] = useState(0)
    const [areaChartPalmOil, setAreaChartPalmOil] = useState(0)
    const [emPerAgriculture, setEmPerAgriculture] = useState(0)
    const [emAgriculture, setEmAgriculture] = useState(0)
    const [ratioAgriculture, setRatioAgriculture] = useState(0)
    const [areaAgriculture, setAreaAgriculture] = useState(0)
    const [areaChartAgriculture, setAreaChartAgriculture] = useState(0)
    const [emArtificial, setEmArtificial] = useState(0)
    const [ratioArtificial, setRatioArtificial] = useState(0)
    const [areaArtificial, setAreaArtificial] = useState(0)
    const [areaChartArtificial, setAreaChartArtificial] = useState(0)
    const [emWater, setEmWater] = useState(0)
    const [ratioWater, setRatioWater] = useState(0)
    const [areaWater, setAreaWater] = useState(0)
    const [areaChartWater, setAreaChartWater] = useState(0)
    const [emOther, setEmOther] = useState(0)
    const [emPerOther, setEmPerOther] = useState(0)
    const [ratioOther, setRatioOther] = useState(0)
    const [areaOther, setAreaOther] = useState(0)
    const [areaChartOther, setAreaChartOther] = useState(0)
    const [statusForm, setStatusForm] = useState('')
    const [sumForm, setSumForm] = useState(0)
    const [sumArea, setSumArea] = useState(0)

    const formatter = (value) => <CountUp end={value} separator=" " decimals={3}/>;

    function close() {
        setIsOpenVegetationSequestration(false)
    }


    useEffect(() => {
        setRatioRainforest(Math.round(data.ratio_rainforest * 100) / 100)
        setRatioMangroves(Math.round(data.ratio_mangroves * 100) / 100)
        setRatioPalmOil(Math.round(data.ratio_palm_oil * 100) / 100)
        setRatioAgriculture(Math.round(data.ratio_agriculture * 100) / 100)
        setRatioArtificial(Math.round(data.ratio_artificial * 100) / 100)
        setRatioWater(Math.round(data.ratio_water * 100) / 100)
        setRatioOther(Math.round(data.ratio_other * 100) / 100)
    }, [data]);

    useEffect(() => {

        setRatioArtificial(floorspaceTotal)

    }, [floorspaceTotal]);

    useEffect(() => {
        setSumArea(areaRainforest + areaMangroves + areaPalmOil + areaAgriculture + areaArtificial + areaWater + areaOther)
    }, [areaRainforest, areaMangroves, areaPalmOil, areaAgriculture, areaArtificial, areaWater, areaOther]);


    useEffect(() => {
        let per = 0
        let value = 0

        value = ((areaRainforest * data.co_seq_rainforest) / 1000000)
        per = ((value / data.rainforest_seq) * 100) - 100
        setEmRainforest(value)
        setEmPerRainforest(Math.round(per))

        value = ((areaMangroves * data.co_seq_mangroves) / 1000000)
        per = ((value / data.mangroves_seq) * 100) - 100
        setEmPerMangroves(Math.round(per))
        setEmMangroves(value)

        value = ((areaPalmOil * data.co_seq_palm_oil) / 1000000)
        per = ((value / data.palm_oil_seq) * 100) - 100
        setEmPerPalmOil(Math.round(per))
        setEmPalmOil(value)

        value = ((areaAgriculture * data.co_seq_agriculture) / 1000000)
        per = ((value / data.agricolture_seq) * 100) - 100
        setEmPerAgriculture(Math.round(per))
        setEmAgriculture(value)

        value = ((areaOther * data.co_other) / 1000000)
        per = ((value / data.other_sequ) * 100) - 100
        setEmPerOther(Math.round(per))
        setEmOther(value)
    }, [sumForm]);

    useEffect(() => {
        const value = ratioRainforest * data.area_total / 100
        setAreaRainforest(value)
        setAreaChartRainforest((value / sumArea) * 240)
    }, [ratioRainforest, sumArea]);

    useEffect(() => {
        const value = ratioMangroves * data.area_total / 100
        setAreaMangroves(value)
        setAreaChartMangroves((value / sumArea) * 240)
    }, [ratioMangroves, sumArea]);

    useEffect(() => {
        const value = ratioPalmOil * data.area_total / 100
        setAreaPalmOil(value)
        setAreaChartPalmOil((value / sumArea) * 240)
    }, [ratioPalmOil, sumArea]);

    useEffect(() => {
        const value = ratioAgriculture * data.area_total / 100
        setAreaAgriculture(value)
        setAreaChartAgriculture((value / sumArea) * 240)
    }, [ratioAgriculture, sumArea]);

    useEffect(() => {
        const value = ratioArtificial * data.area_total / 100
        setAreaArtificial(value)
        setAreaChartArtificial((value / sumArea) * 240)
    }, [ratioArtificial, sumArea]);

    useEffect(() => {
        const value = ratioWater * data.area_total / 100
        setAreaWater(value)
        setAreaChartWater((value / sumArea) * 240)
    }, [ratioWater, sumArea]);

    useEffect(() => {
        const value = ratioOther * data.area_total / 100
        setAreaOther(value)
        setAreaChartOther((value / sumArea) * 240)
    }, [ratioOther, sumArea]);

    useEffect(() => {
        const value = emRainforest + emMangroves + emPalmOil + emAgriculture + emOther
        const per = ((value / data.tot_seq) * 100) - 100
        setEmMainVegetation(value)
        setEmTot(value)
        setEmTotPer(Math.round(per))
    }, [emRainforest, emMangroves, emPalmOil, emAgriculture, emOther]);

    useEffect(() => {

        const value = Math.floor((ratioRainforest + ratioMangroves + ratioPalmOil + ratioAgriculture + ratioArtificial + ratioWater + ratioOther) * 100) / 100

        setSumForm(value)

        if (value >= 99 && value <= 101) {
            setStatusForm('')
            setErrorVegetationSequestration(false)
        } else {
            setStatusForm('error')
            setErrorVegetationSequestration(true)
        }

    }, [ratioRainforest, ratioMangroves, ratioPalmOil, ratioAgriculture, ratioArtificial, ratioWater, ratioOther]);

    return (
        <div className="panelDashboardContainer"
             style={{
                 display: isOpenVegetationSequestration ? 'block' : 'none'
             }}
        >
            <div className="panelDashboardTitleIcon"><CloseCircleOutlined onClick={() => close()}/></div>
            <div className="panelDashboardTitle">Vegetation CO Sequestration</div>

            <div style={{
                padding: '20px 10px 0 10px',
                display: 'flex',
                justifyContent: 'space-evenly',
            }}>
                <div className="panelDashboardSumVeg">
                    {emPerRainforest == 0 && <div style={{height: 22, width: 60}}></div>}
                    {emPerRainforest < 0 && <Tag color="error" style={{width: 50}}>{emPerRainforest} %</Tag>}
                    {emPerRainforest > 0 && <Tag color="success" style={{width: 50}}>{emPerRainforest} %</Tag>}
                    <Statistic
                        title={<span>Natural Rainforest<br/><small>MtCO2e/year</small></span>}
                        value={emRainforest} formatter={formatter}/>
                </div>

                <div className="panelDashboardSumVeg">
                    {emPerMangroves == 0 && <div style={{height: 22, width: 60}}></div>}
                    {emPerMangroves < 0 && <Tag color="error" style={{width: 50}}>{emPerMangroves} %</Tag>}
                    {emPerMangroves > 0 && <Tag color="success" style={{width: 50}}>{emPerMangroves} %</Tag>}
                    <Statistic
                        title={<span>Mangrove Forest<br/><small>MtCO2e/year</small></span>}
                        value={emMangroves} formatter={formatter}/>
                </div>

                <div className="panelDashboardSumVeg">
                    {emPerPalmOil == 0 && <div style={{height: 22, width: 60}}></div>}
                    {emPerPalmOil < 0 && <Tag color="error" style={{width: 50}}>{emPerPalmOil} %</Tag>}
                    {emPerPalmOil > 0 && <Tag color="success" style={{width: 50}}>{emPerPalmOil} %</Tag>}
                    <Statistic
                        title={<span>Palm Oil Plantation<br/><small>MtCO2e/year</small></span>}
                        value={emPalmOil} formatter={formatter}/>
                </div>
            </div>
            <div style={{
                padding: '10px 10px 0 10px',
                display: 'flex',
                justifyContent: 'space-evenly',
            }}>
                <div className="panelDashboardSumVeg">
                    {emPerAgriculture == 0 && <div style={{height: 22, width: 60}}></div>}
                    {emPerAgriculture < 0 && <Tag color="error" style={{width: 50}}>{emPerAgriculture} %</Tag>}
                    {emPerAgriculture > 0 && <Tag color="success" style={{width: 50}}>{emPerAgriculture} %</Tag>}
                    <Statistic
                        title={<span>Mixed Agricolture<br/><small>MtCO2e/year</small></span>}
                        value={emAgriculture} formatter={formatter}/>
                </div>

                <div className="panelDashboardSumVeg">
                    {emPerOther == 0 && <div style={{height: 22, width: 60}}></div>}
                    {emPerOther < 0 && <Tag color="error" style={{width: 50}}>{emPerOther} %</Tag>}
                    {emPerOther > 0 && <Tag color="success" style={{width: 50}}>{emPerOther} %</Tag>}
                    <Statistic
                        title={<span>Other<br/><small>MtCO2e/year</small></span>}
                        value={emOther} formatter={formatter}/>
                </div>

                <div className="panelDashboardSumVeg">
                    {emTotPer == 0 && <div style={{height: 22, width: 60}}></div>}
                    {emTotPer < 0 && <Tag color="error" style={{width: 50}}>{emTotPer} %</Tag>}
                    {emTotPer > 0 && <Tag color="success" style={{width: 50}}>{emTotPer} %</Tag>}
                    <Statistic
                        title={<span>Total<br/><small>MtCO2e/year</small></span>}
                        value={emTot} formatter={formatter}/>
                </div>
            </div>

            <div style={{padding: '0px 20px'}}>
                <Divider orientation="left">Land cover</Divider>
                <Text type="secondary">the sum must be equal 100%</Text>
                <div style={{marginTop: 5}}></div>
                <Row>
                    <Col span={11}>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore160">Natural Rainforest</span>}
                            addonAfter="%"
                            value={ratioRainforest}
                            onChange={(value) => setRatioRainforest(value)}
                        />
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore160">Mangrove Forest</span>}
                            addonAfter="%"
                            value={ratioMangroves}
                            onChange={(value) => setRatioMangroves(value)}
                        />
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore160">Palm oil plantation</span>}
                            addonAfter="%"
                            value={ratioPalmOil}
                            onChange={(value) => setRatioPalmOil(value)}
                        />
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore160">Mixed Agricolture</span>}
                            addonAfter="%"
                            value={ratioAgriculture}
                            onChange={(value) => setRatioAgriculture(value)}
                        />
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            disabled={true}
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore160">* Buildings</span>}
                            addonAfter="%"
                            value={ratioArtificial}
                            onChange={(value) => setRatioArtificial(value)}
                        />
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            disabled={true}
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore160">Permanent water bodies</span>}
                            addonAfter="%"
                            value={ratioWater}
                            onChange={(value) => setRatioWater(value)}
                        />
                        <div style={{marginTop: 10}}></div>
                        <InputNumber
                            status={statusForm}
                            min={0} max={100} precision={2}
                            addonBefore={<span className="dashboardInputBefore160">Other</span>}
                            addonAfter="%"
                            value={ratioOther}
                            onChange={(value) => setRatioOther(value)}
                        />
                        {statusForm === '' && <div style={{
                            marginTop: 10,
                            marginLeft: 125
                        }}><Tag color="success">correct</Tag> {sumForm} %</div>}
                        {statusForm !== '' && <div style={{
                            marginTop: 10,
                            marginLeft: 138,
                            color: '#ff4d4f'
                        }}><Tag color="error">error</Tag> {sumForm} % </div>}
                    </Col>
                    <Col span={1}></Col>
                    <Col span={3}>
                        <Row style={{
                            alignItems: 'center'
                        }}>
                            <Col span={24}
                                 style={{
                                     textAlign: 'right',
                                     fontFamily: 'monospace',
                                     fontSize: '1.1em',
                                     padding: '5px 0'
                                 }}>
                                <CountUp end={areaRainforest} separator=" " duration={0.3}/>
                                <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                            </Col>
                        </Row>
                        <div style={{marginTop: 10}}></div>
                        <Row style={{
                            alignItems: 'center'
                        }}>
                            <Col span={24}
                                 style={{
                                     textAlign: 'right',
                                     fontFamily: 'monospace',
                                     fontSize: '1.1em',
                                     padding: '5px 0'
                                 }}>
                                <CountUp end={areaMangroves} separator=" " duration={0.3}/>
                                <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                            </Col>
                        </Row>
                        <div style={{marginTop: 10}}></div>
                        <Row style={{
                            alignItems: 'center'
                        }}>
                            <Col span={24}
                                 style={{
                                     textAlign: 'right',
                                     fontFamily: 'monospace',
                                     fontSize: '1.1em',
                                     padding: '5px 0'
                                 }}>
                                <CountUp end={areaPalmOil} separator=" " duration={0.3}/>
                                <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                            </Col>
                        </Row>
                        <div style={{marginTop: 10}}></div>
                        <Row style={{
                            alignItems: 'center'
                        }}>
                            <Col span={24} style={{
                                textAlign: 'right',
                                fontFamily: 'monospace',
                                fontSize: '1.1em',
                                padding: '5px 0'
                            }}>
                                <CountUp end={areaAgriculture} separator=" " duration={0.3}/>
                                <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                            </Col>
                        </Row>
                        <div style={{marginTop: 10}}></div>
                        <Row style={{
                            alignItems: 'center'
                        }}>
                            <Col span={24} style={{
                                textAlign: 'right',
                                fontFamily: 'monospace',
                                fontSize: '1.1em',
                                padding: '5px 0'
                            }}>
                                <CountUp end={areaArtificial} separator=" " duration={0.3}/>
                                <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                            </Col>
                        </Row>
                        <div style={{marginTop: 10}}></div>
                        <Row style={{
                            alignItems: 'center'
                        }}>
                            <Col span={24} style={{
                                textAlign: 'right',
                                fontFamily: 'monospace',
                                fontSize: '1.1em',
                                padding: '5px 0'
                            }}>
                                <CountUp end={areaWater} separator=" " duration={0.3}/>
                                <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                            </Col>
                        </Row>
                        <div style={{marginTop: 10}}></div>
                        <Row style={{
                            alignItems: 'center'
                        }}>
                            <Col span={24} style={{
                                textAlign: 'right',
                                fontFamily: 'monospace',
                                fontSize: '1.1em',
                                padding: '5px 0'
                            }}>
                                <CountUp end={areaOther} separator=" " duration={0.3}/>
                                <Text type="secondary" style={{fontSize: '0.8em'}}> km<sup>2</sup></Text>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={1}></Col>
                    <Col span={8}>
                        <div className="chartDashboardBox">
                            <div className="chartDashboardBoxValue"
                                 style={{width: areaChartRainforest}}></div>
                        </div>
                        <div style={{height: 10}}></div>
                        <div className="chartDashboardBox">
                            <div className="chartDashboardBoxValue"
                                 style={{width: areaChartMangroves}}></div>
                        </div>
                        <div style={{height: 10}}></div>
                        <div className="chartDashboardBox">
                            <div className="chartDashboardBoxValue"
                                 style={{width: areaChartPalmOil}}></div>
                        </div>
                        <div style={{height: 10}}></div>
                        <div className="chartDashboardBox">
                            <div className="chartDashboardBoxValue"
                                 style={{width: areaChartAgriculture}}></div>
                        </div>
                        <div style={{height: 10}}></div>
                        <div className="chartDashboardBox">
                            <div className="chartDashboardBoxValue"
                                 style={{width: areaChartArtificial}}></div>
                        </div>
                        <div style={{height: 10}}></div>
                        <div className="chartDashboardBox">
                            <div className="chartDashboardBoxValue"
                                 style={{width: areaChartWater}}></div>
                        </div>
                        <div style={{height: 10}}></div>
                        <div className="chartDashboardBox">
                            <div className="chartDashboardBoxValue"
                                 style={{width: areaChartOther}}></div>
                        </div>
                    </Col>
                </Row>

                <div style={{height: 15}}></div>
                <Text type="secondary">(*) automatically adjusted to figures in the building emissions
                    panel</Text>
                <div style={{height: 15}}></div>
            </div>
        </div>
    )
}